import Model from './model.js';

export default class Admin extends Model
{
    constructor(id, name, description, username, permissions, active, password, confirm_password, created_at = null){
        super()
        this.id         = id ?? 0
        this.name       = name
        this.description= description
        this.username   = username
        this.active     = active??''
        this.permissions= permissions??[]
        this.password   = password
        this.confirm_password= confirm_password
        this.created_at = created_at??null
        this.init()
    }
}

